export const theme = {
    primary: '#242529',
    secondary: '#e2711c',
    cream: '#eae3db'
}